export const EPP_MESSAGE_LIST = 'EPP_MESSAGE_LIST'
export const EPP_MESSAGE_LIST_START = 'EPP_MESSAGE_LIST_START'
export const EPP_MESSAGE_LIST_RESULT = 'EPP_MESSAGE_LIST_RESULT'
export const EPP_MESSAGE_LIST_ERROR = 'EPP_MESSAGE_LIST_ERROR'

export const EPP_MESSAGE_MARK = 'EPP_MESSAGE_MARK'
export const EPP_MESSAGE_MODIFY_READ = 'EPP_MESSAGE_MODIFY_READ'
export const EPP_MESSAGE_DELETE = 'EPP_MESSAGE_DELETE'
